export const CSRF_STORAGE_KEY = "tov_admin_csrf_token";

let inflight: Promise<void> | null = null;

/**
 * Loads a CSRF token into sessionStorage (used by mutating API calls).
 */
export async function ensureCsrfToken(): Promise<void> {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  if (sessionStorage.getItem(CSRF_STORAGE_KEY)) {
    return;
  }
  if (inflight) {
    return inflight;
  }
  inflight = import("./csrfFetch").then(({ fetchCsrfToken }) => fetchCsrfToken());
  try {
    await inflight;
  } finally {
    inflight = null;
  }
}

export function getStoredCsrfToken(): string | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  return sessionStorage.getItem(CSRF_STORAGE_KEY);
}

export function clearStoredCsrfToken(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(CSRF_STORAGE_KEY);
}
export async function refreshCsrfToken(): Promise<void> {
  clearStoredCsrfToken();
  const { fetchCsrfToken } = await import("./csrfFetch");
  await fetchCsrfToken();
}
